import React from 'react';
import Styles from './ResumeGenerator.module.scss';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CircleIcon from '@mui/icons-material/Circle';
import Chip from '@mui/material/Chip';

export function ResumeGenerator({ resumeData, props }) {

    const iconStyles = { fontSize: '10px', mr: '1px' }
    const containerName = process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME_HIRING;
    const profilePicBaseURL = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/${containerName}/profile_picture/`;

    const ExpHTML = ({ expTitle, expData }) => {
        return (
            <div id='expContainer' className={Styles.expContainer}>
                <p id='expTitle' className={Styles.summaryTitle}>
                    {expTitle ? expTitle : "Experience"}
                </p>
                {expData.map((exp, index) => (
                    <span key={`${exp.company_name}-${index}`}>
                        <div key={`${exp.company_name}-${index}`}
                            id={`${index}-exp`}
                            className={Styles.experience}
                        >
                            <p id={`${index}-expPosition`} className={Styles.expPos}>
                                {exp.company_position}
                            </p>
                            <p id={`${index}-expYear`} className={Styles.expYear}>
                                <RespCalendarIcon
                                    fontSize='small'
                                    sx={{ fontSize: '10px', mr: '2px' }}
                                />
                                {exp.company_start_year} - {exp.company_end_year}
                            </p>
                            <p id={`${index}-expName`} className={Styles.expName}>
                                {exp.company_name}
                            </p>
                            {exp.company_accomp &&
                                (exp.company_accomp.trim()).split(/\./).slice(0, 2).map((label, accompIndex) => {
                                    if (label && label.trim() !== '') {
                                        return (
                                            <React.Fragment key={`${accompIndex}-${exp.company_name}`}>
                                                <p className={Styles.expAcc}>
                                                    <RespCircleIcon fontSize='small'
                                                        sx={{ fontSize: '4px', mr: '2px' }} />
                                                    {label.trim()}
                                                </p>
                                            </React.Fragment>
                                        )
                                    }
                                    return null;
                                })
                            }

                        </div>
                        {
                            (expData.length > 1
                                && expData.length - 1 !== index) &&
                            <div key={`${index}-sep`} id='separator' className={Styles.separator} />
                        }
                    </span>
                ))}
            </div>
        )
    }

    const StrengthsHtml = ({ strengths, strengthTitle, number = 3 }) => {

        function truncateText(text, maxLength) {
            if (text.length <= maxLength) {
                return text;
            } else {
                // Truncate and add ellipsis
                return text.slice(0, maxLength) + '...';
            }
        }

        return (
            <div id='strContainer' className={Styles.strContainer}>
                <p
                    id='strengthTitle'
                    className={Styles.summaryTitle}
                    style={{ marginBottom: "0.25em" }}
                >
                    {strengthTitle ? strengthTitle : "Strength"}
                </p>
                {
                    (strengths.trim()).split(/\./).slice(0, number).map((label, strIndex) => {
                        if (label && label.trim() !== '') {
                            return (
                                <React.Fragment key={`${strIndex}-str`}>
                                    <span style={{ display: "flex" }}>
                                        <RespCircleIcon fontSize='small'
                                            sx={{ fontSize: '4px', mr: '2px' }} />
                                        <p className={Styles.expAcc}>
                                            {truncateText(label.trim(), 147)}
                                        </p>
                                    </span>
                                </React.Fragment>
                            )
                        }
                        return null;
                    })
                }
            </div>
        )
    }

    const RespCircleIcon = () => {
        return (
            <CircleIcon
                fontSize='small'
                sx={{ fontSize: '0.4em', m: '1em' }}
            />
        )
    }

    const RespCalendarIcon = () => {
        return (
            <CalendarMonthIcon
                fontSize='small'
                sx={{ fontSize: '0.75em', mr: '0.5em' }}
            />
        )
    }

    return (
        <span id='fullResume'>
            <div id='resumeContainer' className={Styles.resumeContainer}>
                <div id='basicDetails' className={Styles.basicDetails}>
                    <div id='profileContainer' className={Styles.profileContainer}>
                        <p id='profileName' className={Styles.profileName}>
                            {resumeData.first_name} {resumeData.last_name}

                        </p>
                        <img src={profilePicBaseURL + resumeData.profile_picture} className={Styles.profilePic} alt="profilePic" />
                    </div>
                    <span id='contactDetails' className={Styles.contactDetails}>
                        <p>
                            <LocalPhoneIcon fontSize='small' sx={iconStyles} />
                            {resumeData.phone_number}
                        </p>
                        <p>
                            <AlternateEmailIcon fontSize='small' sx={iconStyles} />
                            {resumeData.email}
                        </p>
                        <p>
                            <LocationOnIcon fontSize='small' sx={iconStyles} />
                            {resumeData.location}
                        </p>
                    </span>
                </div>
                <div id='contentContainer' className={Styles.contentContainer}>
                    <div id='leftContainer' className={Styles.leftContainer}>
                        <div id='descrContainer' className={Styles.descrContainer}>
                            <p id='summaryTitle' className={Styles.summaryTitle}>
                                Summary
                            </p>
                            <p id='descr' className={Styles.descr}>
                                {resumeData.description.slice(0, 299)}
                            </p>
                        </div>
                        {
                            <>
                               { resumeData.experience && <ExpHTML
                                    expData={resumeData.experience.slice(0, 2)}
                                />}

                                {/* {resumeData?.experience?.length === 0 &&
                                <StrengthsHtml
                                    strengths={resumeData?.projects}
                                    strengthTitle="Projects of Note"
                                    number={5}
                                />} */}
                                {resumeData?.projects &&
                                    <StrengthsHtml
                                        strengths={resumeData?.projects}
                                        strengthTitle="Projects of Note"
                                        number={5}
                                    />
                                }
                            </>                         
                             
                                
                        
                        }
                    </div>
                    <div id='rightContainer' className={Styles.rightContainer}>
                        <div id='eduContainer' className={Styles.eduContainer}>
                            <p id='eduTitle' className={Styles.summaryTitle}>
                                Education
                            </p>
                            {
                                resumeData.masters &&
                                (
                                    <span>
                                        <p id={`mastersDegree`} className={Styles.expPos}>
                                            {resumeData.masters.masters_name}
                                            <RespCircleIcon />
                                            {resumeData.masters.masters_percentage}%
                                        </p>
                                        <p id={`mastersYear`} className={`${Styles.expYear} `}>
                                            <RespCalendarIcon
                                                fontSize='small'
                                                sx={{ fontSize: '10px', mr: '2px' }}
                                            />
                                            {resumeData.masters.masters_start_year} - {resumeData.masters.masters_end_year}
                                        </p>
                                        <p id={`mastersUni`} className={Styles.expName}>
                                            {resumeData.masters.masters_university}
                                        </p>
                                        <div id='masSeparator' className={Styles.separator} />
                                    </span>
                                )
                            }
                            <span>
                                <p id={`degree`} className={Styles.expPos}>
                                    {resumeData.degree_name}
                                    <RespCircleIcon
                                        fontSize='small'
                                        sx={{ fontSize: '4px', m: '2px' }}
                                    />
                                    {resumeData.degree_percentage}%
                                </p>
                                <p id={`degYear`} className={`${Styles.expYear} `}>
                                    <RespCalendarIcon
                                        fontSize='small'
                                        sx={{ fontSize: '10px', mr: '2px' }}
                                    />
                                    {resumeData.degree_start_year} - {resumeData.degree_end_year}
                                </p>
                                <p id={`degUni`} className={Styles.expName}>
                                    {resumeData.degree_university}
                                </p>
                                <div id='degSeparator' className={Styles.separator} />
                            </span>
                            <span>
                                <p id={`deghighSchool`} className={Styles.expPos}>
                                    {resumeData.high_school_board}
                                    <RespCircleIcon
                                        fontSize='small'
                                        sx={{ fontSize: '4px', m: '2px' }}
                                    />
                                    {resumeData.high_school_percentage}%
                                </p>
                                <p id={`highSchoolYear`} className={`${Styles.expYear} `}>
                                    <RespCalendarIcon
                                        fontSize='small'
                                        sx={{ fontSize: '10px', mr: '2px' }}
                                    />
                                    {resumeData.high_school_start_year} - {resumeData.high_school_end_year}
                                </p>
                                <p id={`highSchoolUni`} className={Styles.expName}>
                                    {resumeData.high_school_name}
                                </p>
                            </span>
                        </div>
                        <div id='skillsContainer' className={Styles.skillsContainer}>
                            <p id='skillsTitle' className={Styles.summaryTitle}>
                                Skills
                            </p>
                            <div id='skillChips' className={Styles.skillChips}>
                                {resumeData.skills.map((skill, index) => (
                                    <span key={`${index}-${skill.tag_name}`}>
                                        <Chip
                                            label={skill.tag_name}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </span>
                                ))}
                            </div>
                        </div>
                        {resumeData.experience ?
                            (
                                <>
                                    <StrengthsHtml
                                        strengths={resumeData.strengths}
                                    />
                                </>
                            ) : (
                                <></>
                            )
                        }
                    </div>
                </div>
            </div>
            {/* {
                ((resumeData?.experience?.length > 3 || resumeData?.projects) && resumeData?.experience) &&
                <div id='resumeSecContainer' className={`${Styles.resumeContainer} ${Styles.resumeSecPage}`}>
                    {resumeData?.experience?.length > 3 &&
                        <ExpHTML
                            expTitle="Highlights"
                            expData={resumeData.experience.slice(3)}
                        />
                    }
                    {(resumeData?.projects && resumeData?.experience) &&
                        <StrengthsHtml
                            strengths={resumeData?.projects}
                            strengthTitle="Projects of Note"
                            number={5}
                        />
                    }
                </div>
            } */}
        </span>
    )
}